module.exports = __webpack_public_path__ + "static/media/photo244.c6bf5385.jpg";